// src/analytics.ts
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-PHMJE84MYK"; // あなたの「測定 ID」に置き換えてください

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
